import React from 'react';

const TermsModal = ({ isOpen, onAccept, onClose }) => {
    const [accepted, setAccepted] = React.useState(false);

    if (!isOpen) return null;

    const handleAccept = () => {
        if (accepted) {
            localStorage.setItem('termsAccepted', 'true');
            onAccept();
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-primary custom-font">
                        Terms and Conditions
                    </h2>
                    <button
                        onClick={onClose}
                        className="btn-close"
                    >
                        ×
                    </button>
                </div>

                <div className="space-y-4 text-primary">
                    <p>Please read and accept our Terms and Conditions before continuing.</p>

                    <p>
                        <a
                            href="/terms"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link-hover"
                        >
                            View Terms and Conditions
                        </a>
                    </p>

                    <div className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            id="terms"
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                            className="checkbox-primary"
                        />
                        <label htmlFor="terms" className="text-sm text-primary">
                            I have read and agree to the Terms and Conditions
                        </label>
                    </div>
                </div>

                <div className="mt-6">
                    <button
                        onClick={handleAccept}
                        disabled={!accepted}
                        className={`btn ${!accepted ? 'btn-disabled pointer-events-none' : ''}`}
                    >
                        Accept and Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TermsModal;